(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ReportingPendingFieldDocumentsController', ReportingPendingFieldDocumentsController);

    ReportingPendingFieldDocumentsController.$inject = ['AlertService', 'ReportingPendingFieldDocuments'];

    function ReportingPendingFieldDocumentsController(AlertService, ReportingPendingFieldDocuments) {
        var vm = this;

        vm.documents = [];
        vm.filteredDocuments = [];
        vm.areas = [];
        vm.filters = {};
        vm.sort = { field: 'lastModifiedDate', direction: 'asc' };
        vm.loading = false;
        vm.load = load;
        vm.applyFilters = applyFilters;
        vm.resetFilters = resetFilters;
        vm.count = count;
        vm.applySort = applySort;

        load();

        function load() {
            vm.loading = true;
            ReportingPendingFieldDocuments.query({}, onSuccess, onError);
        }

        function onSuccess(data) {
            vm.loading = false;
            vm.documents = data || [];
            vm.areas = buildAreas(vm.documents);
            applyFilters();
        }

        function onError(error) {
            vm.loading = false;
            AlertService.error(error && error.data && error.data.message ? error.data.message :
                'wamasysApp.pendingFieldDocuments.loadError');
        }

        function buildAreas(documents) {
            var byId = {};
            angular.forEach(documents, function(document) {
                if (!byId[document.areaId]) {
                    byId[document.areaId] = {
                        id: document.areaId,
                        label: areaLabel(document)
                    };
                }
            });
            return Object.keys(byId).map(function(id) { return byId[id]; }).sort(function(left, right) {
                return left.label.localeCompare(right.label);
            });
        }

        function areaLabel(document) {
            var code = document.areaCode ? document.areaCode + ' - ' : '';
            return code + (document.areaName || '');
        }

        function applyFilters() {
            var search = (vm.filters.search || '').toLowerCase();
            vm.filteredDocuments = vm.documents.filter(function(document) {
                if (vm.filters.type && document.documentType !== vm.filters.type) return false;
                if (vm.filters.status && document.status !== vm.filters.status) return false;
                if (vm.filters.areaId && document.areaId !== vm.filters.areaId) return false;
                if (!search) return true;
                var searchable = [document.reference, document.areaCode, document.areaName,
                    document.creatorLogin, document.collectorLogin, document.collectorDisplayName,
                    document.lastModifiedBy].join(' ').toLowerCase();
                return searchable.indexOf(search) !== -1;
            });
            applySort();
        }

        function sortValue(document) {
            var field = vm.sort.field;
            var value = document[field];
            if (field === 'lastModifiedDate') value = value || document.createdDate;
            if (value === null || value === undefined || value === '') return null;
            if (field === 'createdDate' || field === 'fieldDate' || field === 'lastModifiedDate') {
                var timestamp = new Date(value).getTime();
                return isNaN(timestamp) ? null : timestamp;
            }
            return String(value).toLowerCase();
        }

        function applySort() {
            // Trier la vue filtrée, avec les valeurs absentes en dernier dans les deux sens.
            vm.filteredDocuments.sort(function(left, right) {
                var leftValue = sortValue(left);
                var rightValue = sortValue(right);
                if (leftValue === null && rightValue !== null) return 1;
                if (rightValue === null && leftValue !== null) return -1;
                var compared = 0;
                if (leftValue !== null && rightValue !== null) {
                    compared = typeof leftValue === 'number' ? leftValue - rightValue : leftValue.localeCompare(rightValue);
                }
                if (compared) return vm.sort.direction === 'desc' ? -compared : compared;
                // Départage stable, même après un rafraîchissement ou entre une CL et une RF.
                return (left.documentType + '-' + left.documentId).localeCompare(right.documentType + '-' + right.documentId);
            });
        }

        function resetFilters() {
            vm.filters = {};
            applyFilters();
        }

        function count(type, status) {
            var total = 0;
            angular.forEach(vm.documents, function(document) {
                if ((!type || document.documentType === type) && (!status || document.status === status)) total++;
            });
            return total;
        }
    }
})();
